/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PaymentCommunity from './payment-community';
import PaymentCommunityDetail from './payment-community-detail';
import PaymentCommunityUpdate from './payment-community-update';
import PaymentCommunityDeleteDialog from './payment-community-delete-dialog';

const PaymentCommunityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PaymentCommunity />} />
    <Route path="new" element={<PaymentCommunityUpdate />} />
    <Route path=":id">
      <Route index element={<PaymentCommunityDetail />} />
      <Route path="edit" element={<PaymentCommunityUpdate />} />
      <Route path="delete" element={<PaymentCommunityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PaymentCommunityRoutes;
